import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Navigation } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Button } from "../ui/button";

export const ContactInfo = ({ settings, hours, address, directionsUrl }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">{t("contact.address")}</h3>
        <p className="flex items-start gap-3 text-white text-lg"><MapPin className="text-gold shrink-0 mt-1" size={20} />{address}</p>
      </div>
      <div>
        <h3 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">{t("contact.phone")}</h3>
        <a href={`tel:${(settings?.phone || "0618885582").replace(/\s/g, "")}`} data-testid="contact-phone-link" className="flex items-center gap-3 text-white text-lg hover:text-gold">
          <Phone className="text-gold shrink-0" size={20} />{settings?.phone || "06 18885582"}
        </a>
      </div>
      <div>
        <h3 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">{t("contact.email")}</h3>
        <a href={`mailto:${settings?.email || "info@elitethebarber.com"}`} data-testid="contact-email-link" className="flex items-center gap-3 text-white text-lg hover:text-gold">
          <Mail className="text-gold shrink-0" size={20} />{settings?.email || "info@elitethebarber.com"}
        </a>
      </div>
      <div>
        <h3 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">{t("contact.hoursTitle")}</h3>
        <div className="bg-[#141414] border border-white/5 rounded-xl divide-y divide-white/5">
          {hours && hours.map((h) => (
            <div key={h.weekday} className="flex items-center justify-between px-5 py-3">
              <span className="text-white/80 text-sm">{t(`hours.days.${h.weekday}`)}</span>
              <span className={`text-sm ${h.is_open ? "text-white" : "text-white/40"}`}>
                {h.is_open ? `${h.start_time} – ${h.end_time}` : t("hours.closed")}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-4 pt-2">
        <Link to="/boeken">
          <Button data-testid="contact-book-button" className="bg-gold text-white hover:bg-gold-hover rounded-none px-8">{t("contact.bookCta")}</Button>
        </Link>
        <a href={directionsUrl} target="_blank" rel="noopener noreferrer" data-testid="contact-directions-link">
          <Button variant="outline" className="bg-transparent border border-white/20 text-white hover:border-gold hover:text-gold rounded-none px-8">
            <Navigation size={16} className="mr-2" /> {t("location.directions")}
          </Button>
        </a>
      </div>
      <Link to="/mijn-afspraak" data-testid="contact-manage-appointment-link" className="inline-block text-white/40 text-sm hover:text-gold underline underline-offset-4">
        {t("footer.manageAppointment")}
      </Link>
    </div>
  );
};
